import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const Done = createSvgIcon(
  <svg viewBox="0 0 1000 1000">
    <path d="M923 165l-75-62-25-19-20 26-468 558-138-168-20-23-25 20-75 58-25 22 19 26 239 287 22 33 26-33 571-680 19-23z" />
  </svg>,
  'Done'
);

export default Done;
